import {
  defaultUnitParams,
  toMetric,
  toImperial
} from "./constants"

export default {
  // Turret
  updateIsImperial(state, isImperialUpdate) {
    if (state.isImperial !== isImperialUpdate) {
      state.isImperial = isImperialUpdate;

      if (isImperialUpdate) {
        state.turretHeight = toImperial("cm", state.turretHeight);
        state.turretDiameter = toImperial("cm", state.turretDiameter);
      } else {
        state.turretHeight = toMetric("in", state.turretHeight);
        state.turretDiameter = toMetric("in", state.turretDiameter);
      }
  
      state = Object.assign(state, defaultUnitParams(isImperialUpdate));
    }
  },
  updateTurretHeight(state, newTurretHeight) {
    state.turretHeight = newTurretHeight
  },
  updateTurretDiameter(state, newTurretDiameter) {
    state.turretDiameter = newTurretDiameter
  },
  // Scope
  updateSightHeight(state, newSightHeight) {
    state.sightHeight = newSightHeight
  },
  updateClickUnit(state, newClickUnit) {
    state.clickUnit = newClickUnit
  },
  updateClickValue(state, newClickValue) {
    state.clickValue = newClickValue
  },
  updateClicksPerRotation(state, newClicksPerRotation) {
    state.clicksPerRotation = newClicksPerRotation
  },
  updateDirection(state, newDirection) {
    state.direction = newDirection
  },
  updateNumberOfRevolutions(state, newNumberOfRevolutions) {
    state.numberOfRevolutions = newNumberOfRevolutions
  },
  updateCurrentScope(state, newCurrentScope) {
    state.currentScope = newCurrentScope
  },
  updateMaxNumberOfRevolutions(state, newMaxNumberOfRevolutions) {
    state.maxNumberOfRevolutions = newMaxNumberOfRevolutions
  },
  // Firearm
  updateInitialVelocity(state, newInitialVelocity) {
    state.initialVelocity = newInitialVelocity
  },
  updateZeroRange(state, newZeroRange) {
    state.zeroRange = newZeroRange
  },
  // Environment
  updateAltitude(state, newAltitude) {
    state.altitude = newAltitude
  },
  updatePressure(state, newPressure) {
    state.pressure = newPressure
  },
  updateTemperature(state, newTemperature) {
    state.temperature = newTemperature
  },
  updateHumidity(state, newHumidity) {
    state.humidity = newHumidity
  },
  // Ammunition
  updateDragFunction(state, newDragFunction) {
    state.dragFunction = newDragFunction
  },
  updateDragCoefficient(state, newDragCoefficient) {
    state.dragCoefficient = newDragCoefficient
  },
  updateAmmunitionWeight(state, newAmmunitionWeight) {
    state.ammunitionWeight = newAmmunitionWeight
  },
  updateCurrentAmmunition(state, newCurrentAmmunition) {
    state.currentAmmunition = newCurrentAmmunition
  },
  updateAmmunitionBrand(state, newBrand) {
    state.currentAmmunitionBrand = newBrand
  },
  updateAmmunitionCaliber(state, newCaliber) {
    state.currentAmmunitionCaliber = newCaliber
  },
  // Customization
  updateIsCalculationLoading(state, isCalculationLoading) {
    state.isCalculationLoading = isCalculationLoading
  },
  updateCalculationResults(state, calculationResults) {
    state.calculationResults = calculationResults
  },
  // Product
  updateCurrentScopeProductVariant(state, newCurrentScopeProductVariant) {
    state.currentScopeProductVariant = newCurrentScopeProductVariant
  }
}
